// "Temporary" hack to avoid passing urls through all redux thunk actions that query api data...
export const getApiUrl = (): string => {
    if (typeof window !== 'undefined') {
        return /(dev|local)\./.test(window.location.hostname)
            ? 'https://dev.finn.no/travel-api/prepackage'
            : 'https://www.finn.no/travel-api/prepackage';
    } else {
        const fiaasEnv = process.env.FIAAS_ENVIRONMENT || 'prod';
        return fiaasEnv !== 'prod'
            ? 'https://travel-pale-api.real-estate.svc.dev.finn.no/travel-api/prepackage'
            : 'http://travel-pale-api/travel-api/prepackage';
    }
};
